module.exports = {"fr-FR":{"components":{"paginator":{"first":"","prev":"","next":"","last":""}}}}